import { Component } from "react";
import "../dash.css"
import DashHeader from "../../component/dash_header";
import DashMenu from "../../component/dash_menu";

import { CiCreditCard2 } from "react-icons/ci";
// import { IoLaptopOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import ChatBox from "../../component/chatbox";
// import BNB from "../../asset/images/bnb_logo.png"


class Deposit extends Component {
    state = {
        isMenuVisible: false,
        windowWidth: window.innerWidth
    };

    // Toggles the menu visibility
    toggleMenu = () => {
        this.setState((prevState) => ({
            isMenuVisible: !prevState.isMenuVisible
        }));
    };

    // Handle window resize event
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    // Adjust menu visibility based on window width
    adjustMenuVisibility = () => {
        const { windowWidth, isMenuVisible } = this.state;
        if (windowWidth > 1100 && !isMenuVisible) {
            this.setState({ isMenuVisible: true });
        } else if (windowWidth <= 1100 && isMenuVisible) {
            this.setState({ isMenuVisible: false });
        }
    };

    // Clean up resize event listener when component unmounts
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    // Update menu visibility when window width changes
    componentDidUpdate(prevProps, prevState) {
        if (prevState.windowWidth !== this.state.windowWidth) {
            this.adjustMenuVisibility();
        }
    }

    componentDidMount() {
     
        window.addEventListener("resize", this.handleResize);
        this.adjustMenuVisibility(); // Initial visibility check
    }








    render() {
         const {isMenuVisible} = this.state

        return (
            <div className="dashboard">
                <DashHeader toggleMenu={this.toggleMenu} />
                <div className="dash_body_container">
                    <DashMenu  isMenuVisible={isMenuVisible} toggleMenu={this.toggleMenu}/>
                    <div className="dash_content_container">
                        <div className="dash_contain">
                            <div className="dash_head">
                                <h3>Deposit</h3>
                                <p>Select your preferred payment method</p>
                            </div>




                            <div className="dash_List_container">
                                <Link to="/deposit/bitcoin" >
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><img src="https://pp.ekspp.com/cdn/pm-icons/bitcoin/48/True.svg" alt="bitcon" /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4>Bitcoin (BTC)</h4>
                                                    <p className="green">Recommended</p>
                                                </div>
                                                <p className="body">Processing time <span>Instant - 45 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link>

                                <Link to="/deposit/ethereum">
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><img src="https://pp.ekspp.com/cdn/pm-icons/ethereum/48/True.svg" alt="bitcon" /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4>Ethereum (ETH)</h4>
                                                </div>
                                                <p className="body">Processing time <span>Instant - 45 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link>


                                {/* <Link to="/deposit/bnb">
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><img src={BNB} alt="bitcon" /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4>BNB</h4>
                                                    <p className="green">Recommended</p>
                                                </div>
                                                <p className="body">Processing time <span>Instant - 45 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link>


                                <Link to="/deposit/tether_trc">
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><img src="https://pp.ekspp.com/cdn/pm-icons/usdt-trc20/48/True.svg" alt="bitcon" /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4> Tether (USDT TRC20)</h4>
                                                </div>
                                                <p className="body">Processing time <span>Instant - 45 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link> */}


                                <Link to="/deposit/bank_card">
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><CiCreditCard2 /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4>Buy Crypto with Card</h4>
                                                    {/* <p className="green">Recommended</p> */}
                                                </div>
                                                <p className="body">Processing time <span>Instant - 15 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link>




                                {/* <Link to="/deposit/online_transfer">
                                    <section className="dash_cryp_list_contain">
                                        <div className="cover">
                                            <div className="icon"><IoLaptopOutline /></div>
                                            <div className="content">
                                                <div className="head">
                                                    <h4>Online Bank Transfer</h4>
                                                </div>
                                                <p className="body">Processing time <span>Instant - 45 mintue</span></p>
                                                <p className="body">Fee <span>0%</span></p>
                                                <p className="body">Limit <span>12 - 10,000 USD</span></p>
                                            </div>
                                        </div>
                                    </section>
                                </Link> */}
                            </div>

                        </div>
                    </div>
                </div>
                <ChatBox />

            </div>
        )
    }
}



export default Deposit